export var ReplyType;
(function (ReplyType) {
    ReplyType["OK"] = "01010000";
    ReplyType["Unsupported"] = "01030000";
})(ReplyType || (ReplyType = {}));
